import { useMemo } from 'react';

import {
  GridColDef,
  GridRenderCellParams,
  selectFilterConfig,
  textFilterConfig,
} from '@sbv-clients/ui-shared';
import { nameOfFactory } from '@sbv-clients/util-misc';

import { AdminFacilityElasticEmployeeType } from '../../../services/admin-facility';
import { EmployeeHealthProblemBadgeCollection } from './employee-health-problem-badge';
import { OnboardingHealthStatusConst } from './onboarding-health-status-const';

const employeeRowKey = nameOfFactory<AdminFacilityElasticEmployeeType>();

const useColumns = () => {
  return useMemo(() => {
    const columns: GridColDef<AdminFacilityElasticEmployeeType>[] = [
      {
        type: 'string',
        field: employeeRowKey('firstName'),
        headerName: 'First Name',
        width: 200,
        ...textFilterConfig(),
      },
      {
        type: 'string',
        field: employeeRowKey('lastName'),
        headerName: 'Last Name',
        width: 200,
        ...textFilterConfig(),
      },
      {
        type: 'string',
        field: employeeRowKey('employeeId'),
        headerName: 'Employee ID',
        width: 200,
        ...textFilterConfig(),
      },
      {
        field: employeeRowKey('role'),
        headerName: 'Role',
        width: 150,
        ...selectFilterConfig(),
        valueOptions: [
          { value: 'Desktop', label: 'Desktop' },
          { value: 'Mobile', label: 'Mobile' },
        ],
      },
      {
        type: 'string',
        field: employeeRowKey('mobilePhone'),
        headerName: 'Phone',
        width: 200,
        ...textFilterConfig(),
      },
      {
        type: 'string',
        field: employeeRowKey('legacyLoginId'),
        headerName: 'Login ID',
        width: 200,
        ...textFilterConfig(),
      },
      {
        field: 'onboardingHealthStatus',
        headerName: 'Onboarding Health Status',
        width: 150,
        ...selectFilterConfig(),
        valueOptions: [
          {
            value: OnboardingHealthStatusConst.READY.value,
            label: OnboardingHealthStatusConst.READY.name,
          },
          {
            value: OnboardingHealthStatusConst.OTHER_MATCHES.value,
            label: OnboardingHealthStatusConst.OTHER_MATCHES.name,
          },
          {
            value: OnboardingHealthStatusConst.DUPLICATE_PHONE.value,
            label: OnboardingHealthStatusConst.DUPLICATE_PHONE.name,
          },
          {
            value: OnboardingHealthStatusConst.DUPLICATE_LOGIN.value,
            label: OnboardingHealthStatusConst.DUPLICATE_LOGIN.name,
          },
          {
            value: OnboardingHealthStatusConst.INVALID_MOBILE_PHONE.value,
            label: OnboardingHealthStatusConst.INVALID_MOBILE_PHONE.name,
          },
        ],
        renderCell: (
          params: GridRenderCellParams<AdminFacilityElasticEmployeeType>
        ) => {
          return (
            <EmployeeHealthProblemBadgeCollection
              onboardingHealthStatusList={
                params.row.onboardingHealthStatusList ?? []
              }
              duplicateLoginIdEmployees={params.row.duplicateLoginIdHits ?? []}
              duplicateMobilePhoneEmployees={
                params.row.duplicatePhoneHits ?? []
              }
              linkedEmployees={params.row.linkedEmployees ?? []}
            ></EmployeeHealthProblemBadgeCollection>
          );
        },
      },
    ];
    return columns;
  }, []);
};

export default useColumns;
